<template>
    <section id="home-slide-prices" class="flex flex-col flex-wrap content-center p-5 text-start container-fluid">

        <div class="my-4 text-center">
            <h1>{{ gettext("Nos formules") }}</h1>
            <small class="shrink-4">{{ gettext("Des formules adaptées à tous vos besoins") }}</small>
        </div>
        <div class="simulator ">
            <img src="/static/img/logo/Octolo-512.svg" />
            <div>
                <h2>{{ gettext("Simuler le tarif :") }}</h2>
                <p>{{ gettext("Nombre de personnes") }}</p>
                <div class="number-member">
                    <input class="number-input" type="number" max="99999999999" min="0" v-model="myInput"/>
                    <div class="minus" @click="memberDecr()"><fa icon="minus"/></div>
                    <div class="add" @click="memberIncre()"><fa icon="plus"/></div>
                </div>
            </div>

        </div>
        <div class="row text-center card-container">
            <div id="price-simple" class="col-lg card-test py-[15px] px-0">
                <div class="card">
                    <div class="card-header">
                        <h4>{{ gettext("Une réunion") }}</h4>
                    </div>
                    <div class="card-body">
                        <h1 class="card-title pricing-card-title">
                            <div class="price">{{ priceWithoutSubs }}  €</div><div class="price-underline"></div>
                        </h1>
                        <div><small class="text-muted mt-0">{{ gettext("200€ +10€ par invité") }}</small></div>
                        <br>
                        <p>
                            Organisation d'une assemblée générale (création de documents, convocations électroniques, vote en ligne et création du PV).
                            Sans abonnement.
                        </p>
                        <ul class="text-start ms-lg-5 ps-lg-5">
                            <li>{{ gettext("Création de documents") }}</li>
                            <li>{{ gettext("Convocations électroniques") }}</li>
                            <li>{{ gettext("Vote en ligne") }}</li>
                            <li>{{ gettext("création du PV") }}</li>
                        </ul>

                    </div>
                    <div class="pb-3">
                        <octolo-buttonv2 class="lg" @click="goToContact()">{{ gettext("Demander plus d'informations") }}</octolo-buttonv2>
                    </div>
                </div>
            </div>

            <div id="price-subs" class="col-lg card-test py-[15px] px-0">
                <div class="card">
                    <div class="card-header">
                        <h4>{{ gettext("Abonnement") }}</h4>
                    </div>
                    <div class="card-body">
                        <h1 class="card-title pricing-card-title">
                            <div class="price">{{subscribeInput()}}€ par an</div><div class="price-underline"></div>
                        </h1>
                        <!-- <div :class="{hiden:isActive}"><p> par utilisateur<small class="text-muted"> {{ gettext("/ mois") }}</small></p></div> -->
                        <div><small class="text-muted">{{ gettext("Soit 2€ par utilisateur par mois") }}</small></div>
                        <div><small class="text-muted">{{ gettext("Tarif plancher: de 1 à 20 utilisateurs = 500€ par an") }} </small></div>
                        <p class="px-2" >
                            Une formule complète et un accompagnement sur mesure pour davantage de sérénité.
                        </p>
                        <ul class="text-start ms-lg-5 ps-lg-5">
                            <li>{{ gettext("Tenue des registres") }}</li>
                            <li>{{ gettext("Organisation illimité de réunions") }}</li>
                            <li>{{ gettext("Création de documents") }}</li>
                            <li>{{ gettext("Convocations électroniques") }}</li>
                            <li>{{ gettext("Vote en ligne") }}</li>
                            <li>{{ gettext("création du PV") }}</li>
                        </ul>
                    </div>
                    <div class="pb-3">
                        <octolo-buttonv2 class="lg" @click="goToContact()">{{ gettext("Demander plus d'informations") }}</octolo-buttonv2>
                    </div>
                </div>
            </div>

            <div id="price-devis" class="col-lg card-test py-[15px] px-0">
                <div class="card">
                    <div class="card-header">
                        <h4>{{ gettext("Cabinet") }}</h4>
                    </div>
                    <div class="card-body">
                    <h1>
                        <div class="price">{{ gettext("Sur devis") }}</div><div class="price-underline"></div>
                    </h1>
                        <div><small class="text-muted">{{ gettext("A partir de 50€ par an (tarif dégressif)") }}</small></div>
                        <br>
                        <p class="px-1">
                            Gestion collaborative de plusieurs entreprises depuis un seul compte.
                        </p>
                        <ul class="text-start ms-lg-5 ps-lg-5">
                            <li>{{ gettext("Tenue des registres") }}</li>
                            <li>{{ gettext("Organisation illimité de réunions") }}</li>
                            <li>{{ gettext("Création de documents") }}</li>
                            <li>{{ gettext("Convocations électroniques") }}</li>
                            <li>{{ gettext("Vote en ligne") }}</li>
                            <li>{{ gettext("création du PV") }}</li>
                        </ul>
                    </div>
                    <div class="pb-3">
                        <octolo-buttonv2 class="lg" @click="goToContact()">{{ gettext("Demander plus d'informations") }}</octolo-buttonv2>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom">
            <h4>{{ gettext("Vous êtes une association ? Une jeune start-up ? Contactez-nous pour bénéficier d'un tarif spécifique !") }}</h4>
            <div class="px-2.5">
                <octolo-buttonv2 class=" primary" icon="arrow-right" @click="goToContact()">
                    <span>{{ gettext("Nous contacter") }}</span>
                </octolo-buttonv2>
            </div>
        </div>
    </section>
</template>
<script>
import slide from "@/pages/homepage/slide/slide.js";

export default {
    mixins: [slide],
    data(){
        return {
            persons_nb: 1,
            minMember:500,
            // isActive : false,
        }
    },
    computed: {
        myInput:{
            set(val){ this.persons_nb = val >= 1 && val < 9001? val : 1; },
            get(){ return this.persons_nb; }
        },
        priceWithoutSubs(){
            return this.persons_nb*10+200;
        },
    },
    methods: {
        subscribeInput(){
            if(this.myInput<=20){
                return this.minMember
            }else{
                return this.myInput*24;
            }
        },
        memberIncre() {if(this.myInput < 9000)this.myInput+=1},
        memberDecr (){if(this.myInput > 1)this.myInput-=1;},
    }


}
</script>

<style scoped lang="scss">
@import "@/assets/vars.scss";
#home-slide-prices {
    background-color: white;
    color: $primary;

    .bottom {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 15px;
    }
    // .card-container {width: 90%;}
    #price-subs, #price-simple, #price-devis {
        display: flex;
        justify-content: center;
    }

    #price-subs {
        .card-header{text-decoration-color: $secondary;}
        .price-underline{background-color: $secondary;}
        button {background-color: $secondary;}
        .hiden {
            display: none !important;
            background-color: red !important;
        }

    }
    #price-simple {
        .card-header{text-decoration-color: #0AC3DC;}
        .price-underline{background-color: #0AC3DC;}
        button {background-color: #0AC3DC;}
    }
    #price-devis {
        .card-header {text-decoration-color: #FFCC00;}
        .price-underline{background-color: #FFCC00;}
        button {background-color: #FFCC00;}
    }

    .card-header {
        text-align: left;
        background-color: transparent;
        border: none;
        text-decoration: underline;
        text-decoration-thickness: 3px;
    }
    .card-test {
        margin-right: 10px;
        &:hover .card{
            box-shadow: 0px 0px 25px 1px rgba(0,0,0,0.1);
            transform: translateY(-10px);
            transition: transform 0.4s ease;
        }
    }
    .card{
        background-color: #FAFAFA;
        border-radius: 25px;
        border: none;
        color: $octo-primary;
        // padding: 15px 0px;
        // margin: 15px;
        height: 100%;
        width: 360px;

       p,ul {
            margin: 15px;
       }
       .card-title {
        margin-bottom: 0;
       }

        .price,h1 {display: inline-block;}
        .text-muted, .price, h4 {
            user-select: none;
            padding-top: 0 !important;
        }
        .price{
            position: relative;
            z-index: 1;
        }
        .price-underline {
            position: relative;
            height: 12px;
            bottom:15px;
            z-index: 0;
        }

    }
    .simulator {
        display: flex;
        align-items: center;
        height: 95px;
        margin-bottom: 60px;
        img {height: 100%;}
    }
    .number-member {
        border-radius: 10px;
        border: 0.13em solid $primary;
        display: flex;
        align-items: center;
        width: 135px;
        margin-top: 3px;

        input {
            border: transparent;
            color: $primary;
            width: 70%;
            margin: 2px 4px;
            border-radius: inherit 0 0 inherit;
            font-weight: bold;
            border-right: 0.13em solid $primary;

        }
        input[type=number]::-webkit-inner-spin-button,
        input[type=number]::-webkit-outer-spin-button {
            opacity: 0;
        }
        input[type=number] {
         -moz-appearance: textfield;
        }
        .add, .minus {
            margin: 0px 5px;
            cursor: pointer;
        }
    }

}

.pb-3 button {
        color: $primary;
        border-radius: 6px;
        &:hover {
            background-color: $primary !important;
            color:white;
        }
    }
@media (max-width: $smartphoneScreenSize) {
    .flex {
        align-items: center!important;
    }
    #home-slide-prices .card-container {
        width: auto;
    }

}

</style>
